import * as angular from "angular";
import {IComponentOptions, ILogService, IScope, IWindowService} from "angular";
import moment = require("moment");
import {SamlResponse} from "../../model/SamlResponse";
import {sprintf} from "sprintf-js";
import "./login.less";
import {StateParams, StateService} from "@uirouter/angularjs";
import {AuthService} from "../auth.service";
import {LoginDetails} from "../../model/LoginDetails";
import {ApplicationService} from "../../application/application.service";


class LoginFormController2 {
    public user;
    public model: SamlResponse;
    public SAMLResponse: any;
    public selectedGroups: string[];
    public processing = false;
    public loadMessage = "";
    public action: string;
    public SAML_ATTRIBUTE: string = "<saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%s</saml2:AttributeValue>";
    public SAML_RESPONSE_FORMAT: string = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n" +
        "<saml2p:Response Destination=\"%(destination)s\" ID=\"id36520493042024881539860353\" InResponseTo=\"_c32de23f-a147-4171-94bb-736110d9626d\" IssueInstant=\"%(notBefore)s\"  " +
        "Version=\"2.0\" xmlns:saml2p=\"urn:oasis:names:tc:SAML:2.0:protocol\" xmlns:xs=\"http://www.w3.org/2001/XMLSchema\">\n" +
        "    <saml2:Issuer Format=\"urn:oasis:names:tc:SAML:2.0:nameid-format:entity\" xmlns:saml2=\"urn:oasis:names:tc:SAML:2.0:assertion\">%(issuer)s</saml2:Issuer>\n" +
        "    <ds:Signature xmlns:ds=\"http://www.w3.org/2000/09/xmldsig#\">\n" +
        "        <ds:SignedInfo>\n" +
        "            <ds:CanonicalizationMethod Algorithm=\"http://www.w3.org/2001/10/xml-exc-c14n#\"/>\n" +
        "            <ds:SignatureMethod Algorithm=\"http://www.w3.org/2001/04/xmldsig-more#rsa-sha256\"/>\n" +
        "            <ds:Reference URI=\"#id36520493042024881539860353\">\n" +
        "                <ds:Transforms>\n" +
        "                    <ds:Transform Algorithm=\"http://www.w3.org/2000/09/xmldsig#enveloped-signature\"/>\n" +
        "                    <ds:Transform Algorithm=\"http://www.w3.org/2001/10/xml-exc-c14n#\">\n" +
        "                        <ec:InclusiveNamespaces PrefixList=\"xs\" xmlns:ec=\"http://www.w3.org/2001/10/xml-exc-c14n#\"/>\n" +
        "                    </ds:Transform>\n" +
        "                </ds:Transforms>\n" +
        "                <ds:DigestMethod Algorithm=\"http://www.w3.org/2001/04/xmlenc#sha256\"/>\n" +
        "                <ds:DigestValue>7RKHJg6aXR9JWkLGegWC2UnTg9INyroWsQz2kPY9uzI=</ds:DigestValue>\n" +
        "            </ds:Reference>\n" +
        "        </ds:SignedInfo>\n" +
        "        <ds:SignatureValue>MMYRLBNWd8N4wWHWJthUnpb/Jiuodg3kjlcopma4Mo51QuKxuJEt1E7/U17KHa3i66uMhhzsF3GVhXzzY46OrFqxBuErE9fzaOWGN4zeai2" +
        "OIhzOqSz1YMPaNglCfoiOn11wgJIPg9sj5XdHetI5vp73ROD3Pc+8cN/3+y7sajVVLG5q36yIFcZRhKxkj45WAgV8vAaoM0YsArAunRoJVcdIyVPrNT99inlsjEsQAvLil8G0xrVf" +
        "mfmVqW3JEl5A7invR9eDJ5RgSIaWDJWVqN8OlUqFq0jOfwtEPmDua3bPGi1znVlb9+Ov4afTOqc5BycsEeXE4hLiisjFZuAlDA==</ds:SignatureValue>\n" +
        "        <ds:KeyInfo>\n" +
        "            <ds:X509Data>\n" +
        "                <ds:X509Certificate>MIIDpjCCAo6gAwIBAgIGAWMhcUsYMA0GCSqGSIb3DQEBCwUAMIGTMQswCQYDVQQGEwJVUzETMBEG\n" +
        "                    A1UECAwKQ2FsaWZvcm5pYTEWMBQGA1UEBwwNU2FuIEZyYW5jaXNjbzENMAsGA1UECgwET2t0YTEU\n" +
        "                    MBIGA1UECwwLU1NPUHJvdmlkZXIxFDASBgNVBAMMC21vbmFzaHVuaXFhMRwwGgYJKoZIhvcNAQkB\n" +
        "                    Fg1pbmZvQG9rdGEuY29tMB4XDTE4MDUwMjE1MjAwM1oXDTI4MDUwMjE1MjEwMlowgZMxCzAJBgNV\n" +
        "                    BAYTAlVTMRMwEQYDVQQIDApDYWxpZm9ybmlhMRYwFAYDVQQHDA1TYW4gRnJhbmNpc2NvMQ0wCwYD\n" +
        "                    VQQKDARPa3RhMRQwEgYDVQQLDAtTU09Qcm92aWRlcjEUMBIGA1UEAwwLbW9uYXNodW5pcWExHDAa\n" +
        "                    BgkqhkiG9w0BCQEWDWluZm9Ab2t0YS5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIB\n" +
        "                    AQCuOJRVVDR7FNuNa18eZU/WlBNt+CkDnyFrnxJPf4R/gH59EQvG3YV/3UR42LEoSbgFeFcQ6VFf\n" +
        "                    G+5ebh7YGrLEETzCIA1swHzOWd9NkfTmBBswcYryeFHQn1Cx/mNdlKyf7Or0uGrq2DGiVU18z9BN\n" +
        "                    mDi52eB0RW2Z1zhAeTa3ODo2yR8dPu+s3ZygadCr+R3KK7DZYv2wStiua0gJcMtdye0fhY6kNLM1\n" +
        "                    qPMr1BgTTfmRSgUUHjWhyGZpxvZCu5Y2EDXu5zkDz6D3yXTKY7ShzrHwpIicj+pos15D0fcqVlFc\n" +
        "                    oQWrhwKfhlQcxZbFNlCMl5CBzW1hBswm8mjitPS1AgMBAAEwDQYJKoZIhvcNAQELBQADggEBAIvl\n" +
        "                    nQSakv4oAucCPVLWPKG+OtCX9hIzt+LXn8FuoAE+33Ffljh/z3MMbD0yp9b0IhnBaUok1Gy2LhAS\n" +
        "                    XqxSBZ5SyzZrYql5wVRVJntlg2me6wvVX4mAWERqaruY20sbbdNvyKM7RQ6Ve+ld4e80mwOASXtR\n" +
        "                    aPLIyj6uqL7J1he/MKeXyfsQyZeM8r++fPKw+u5lBDOBgNLnszoTxPN3sUZzUDCEtnmbov9VNyuX\n" +
        "                    cAVIuO733ZLzRO0IZCeATBSI/jTIIUKzIiEQlvuQoou3hGIVDY8ZmtUqTen/2MRmbSi3AwtOAqBy\n" +
        "                    F+ohGgBsZhDmum2hN34Zhq+\n" +
        "                    pLxD5VzYPKL4=</ds:X509Certificate>\n" +
        "            </ds:X509Data>\n" +
        "        </ds:KeyInfo>\n" +
        "    </ds:Signature>\n" +
        "    <saml2p:Status>\n" +
        "        <saml2p:StatusCode Value=\"urn:oasis:names:tc:SAML:2.0:status:Success\"/>\n" +
        "    </saml2p:Status>\n" +
        "    <saml2:Assertion ID=\"id36520493042862632061505632\" IssueInstant=\"2018-07-13T06:56:52.920Z\" Version=\"2.0\"" +
        " xmlns:saml2=\"urn:oasis:names:tc:SAML:2.0:assertion\">\n" +
        "        <saml2:Issuer Format=\"urn:oasis:names:tc:SAML:2.0:nameid-format:entity\">%(issuer)s</saml2:Issuer>\n" +
        "        <ds:Signature xmlns:ds=\"http://www.w3.org/2000/09/xmldsig#\">\n" +
        "            <ds:SignedInfo>\n" +
        "                <ds:CanonicalizationMethod Algorithm=\"http://www.w3.org/2001/10/xml-exc-c14n#\"/>\n" +
        "                <ds:SignatureMethod Algorithm=\"http://www.w3.org/2001/04/xmldsig-more#rsa-sha256\"/>\n" +
        "                <ds:Reference URI=\"#id36520493042862632061505632\">\n" +
        "                    <ds:Transforms>\n" +
        "                        <ds:Transform Algorithm=\"http://www.w3.org/2000/09/xmldsig#enveloped-signature\"/>\n" +
        "                        <ds:Transform Algorithm=\"http://www.w3.org/2001/10/xml-exc-c14n#\">\n" +
        "                            <ec:InclusiveNamespaces PrefixList=\"xs\" xmlns:ec=\"http://www.w3.org/2001/10/xml-exc-c14n#\"/>\n" +
        "                        </ds:Transform>\n" +
        "                    </ds:Transforms>\n" +
        "                    <ds:DigestMethod Algorithm=\"http://www.w3.org/2001/04/xmlenc#sha256\"/>\n" +
        "                    <ds:DigestValue>OQ/EdhU4VZtY8scNoriiBXDk9/DbaJHbZlC8qIaL2+\n" +
        "                        8=</ds:DigestValue>\n" +
        "                </ds:Reference>\n" +
        "            </ds:SignedInfo>\n" +
        "            <ds:SignatureValue>nfpY0kkwYrlUuEVE0ybvqHwgqp3eJkbWr3qUAMph7vUMbNemGZSGOLEZO9RdzG+XCiacIOcUfR3eq4bd/iSu4Tq8wMzZ9L9cY8vwKSwxUeCOPP264QuTuSyxbmb3/sxPFCqU/hZZcv" +
        "BNbWJw1so+Aqz764TwZmbfIWB3NRgEyoXDaA0oc+CSKFYq4GSX/KnPtiJlxQ+h7ZFG80hFokxKM/akoeZTcwDKNxvxu4AWwlOzz4Q3hq7xXFlM32RL9FvkMAVz+h+Y+ggaeds3FiQQj9rfvzQYFNNdtGeDu7KRda7fwOmlzy0j" +
        "kWchql28Dy/gRy05t0o5cfHmpooZwf2lHw==</ds:SignatureValue>\n" +
        "            <ds:KeyInfo>\n" +
        "                <ds:X509Data>\n" +
        "                    <ds:X509Certificate>MIIDpjCCAo6gAwIBAgIGAWMhcUsYMA0GCSqGSIb3DQEBCwUAMIGTMQswCQYDVQQGEwJVUzETMBEG\n" +
        "                        A1UECAwKQ2FsaWZvcm5pYTEWMBQGA1UEBwwNU2FuIEZyYW5jaXNjbzENMAsGA1UECgwET2t0YTEU\n" +
        "                        MBIGA1UECwwLU1NPUHJvdmlkZXIxFDASBgNVBAMMC21vbmFzaHVuaXFhMRwwGgYJKoZIhvcNAQkB\n" +
        "                        Fg1pbmZvQG9rdGEuY29tMB4XDTE4MDUwMjE1MjAwM1oXDTI4MDUwMjE1MjEwMlowgZMxCzAJBgNV\n" +
        "                        BAYTAlVTMRMwEQYDVQQIDApDYWxpZm9ybmlhMRYwFAYDVQQHDA1TYW4gRnJhbmNpc2NvMQ0wCwYD\n" +
        "                        VQQKDARPa3RhMRQwEgYDVQQLDAtTU09Qcm92aWRlcjEUMBIGA1UEAwwLbW9uYXNodW5pcWExHDAa\n" +
        "                        BgkqhkiG9w0BCQEWDWluZm9Ab2t0YS5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIB\n" +
        "                        AQCuOJRVVDR7FNuNa18eZU/WlBNt+CkDnyFrnxJPf4R/gH59EQvG3YV/3UR42LEoSbgFeFcQ6VFf\n" +
        "                        G+5ebh7YGrLEETzCIA1swHzOWd9NkfTmBBswcYryeFHQn1Cx/mNdlKyf7Or0uGrq2DGiVU18z9BN\n" +
        "                        mDi52eB0RW2Z1zhAeTa3ODo2yR8dPu+s3ZygadCr+R3KK7DZYv2wStiua0gJcMtdye0fhY6kNLM1\n" +
        "                        qPMr1BgTTfmRSgUUHjWhyGZpxvZCu5Y2EDXu5zkDz6D3yXTKY7ShzrHwpIicj+pos15D0fcqVlFc\n" +
        "                        oQWrhwKfhlQcxZbFNlCMl5CBzW1hBswm8mjitPS1AgMBAAEwDQYJKoZIhvcNAQELBQADggEBAIvl\n" +
        "                        nQSakv4oAucCPVLWPKG+OtCX9hIzt+LXn8FuoAE+33Ffljh/z3MMbD0yp9b0IhnBaUok1Gy2LhAS\n" +
        "                        XqxSBZ5SyzZrYql5wVRVJntlg2me6wvVX4mAWERqaruY20sbbdNvyKM7RQ6Ve+ld4e80mwOASXtR\n" +
        "                        aPLIyj6uqL7J1he/MKeXyfsQyZeM8r++fPKw+u5lBDOBgNLnszoTxPN3sUZzUDCEtnmbov9VNyuX\n" +
        "                        cAVIuO733ZLzRO0IZCeATBSI/jTIIUKzIiEQlvuQoou3hGIVDY8ZmtUqTen/2MRmbSi3AwtOAqBy\n" +
        "                        F+ohGgBsZhDmum2hN34Zhq+\n" +
        "                        pLxD5VzYPKL4=</ds:X509Certificate>\n" +
        "                </ds:X509Data>\n" +
        "            </ds:KeyInfo>\n" +
        "        </ds:Signature>\n" +
        "        <saml2:Subject>\n" +
        "            <saml2:NameID Format=\"urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress\">%(username)s</saml2:NameID>\n" +
        "            <saml2:SubjectConfirmation Method=\"urn:oasis:names:tc:SAML:2.0:cm:bearer\">\n" +
        "                <saml2:SubjectConfirmationData InResponseTo=\"_c32de23f-a147-4171-94bb-736110d9626d\" NotOnOrAfter=\"%(notOnOrAfter)s\" " +
        "Recipient=\"%(subjectConfirmationData)s\"/>\n" +
        "            </saml2:SubjectConfirmation>\n" +
        "        </saml2:Subject>\n" +
        "        <saml2:Conditions NotBefore=\"2018-07-13T06:51:52.921Z\" NotOnOrAfter=\"2018-07-13T07:01:52.921Z\">\n" +
        "            <saml2:AudienceRestriction>\n" +
        "                <saml2:Audience>%(audience)s</saml2:Audience>\n" +
        "            </saml2:AudienceRestriction>\n" +
        "        </saml2:Conditions>\n" +
        "        <saml2:AuthnStatement AuthnInstant=\"2018-07-13T01:37:28.844Z\" SessionIndex=\"_c32de23f-a147-4171-94bb-736110d9626d\">\n" +
        "            <saml2:AuthnContext>\n" +
        "                <saml2:AuthnContextClassRef>urn:oasis:names:tc:SAML:2.0:ac:classes:PasswordProtectedTransport</saml2:AuthnContextClassRef>\n" +
        "            </saml2:AuthnContext>\n" +
        "        </saml2:AuthnStatement>\n" +
        "        <saml2:AttributeStatement>\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(givenName)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(surname)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(email)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/claims/CommonName\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(givenName)s %(surname)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(username)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.microsoft.com/ws/2008/06/identity/claims/saml_student_code\" " +
        "NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(callistaPersonId)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/callistaPersonID\" " +
        "NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(callistaPersonId)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "\n" +
        "            <saml2:Attribute Name=\"http://schemas.microsoft.com/ws/2008/06/identity/claims/sapEmployeeNumber\" " +
        "NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                <saml2:AttributeValue xmlns:xsi=\"http://www.w3.org/2001/XMLSchema-instance\" xsi:type=\"xs:string\">%(sapEmployeeNumber)s</saml2:AttributeValue>\n" +
        "            </saml2:Attribute>\n" +
        "           <saml2:Attribute Name=\"http://schemas.microsoft.com/ws/2008/06/identity/claims/organizationalRelationships\" " +
        "NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                %(roles)s\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.microsoft.com/ws/2008/06/identity/claims/role\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "                %(roles)s\n" +
        "            </saml2:Attribute>\n" +
        "            <saml2:Attribute Name=\"http://schemas.xmlsoap.org/claims/Group\" NameFormat=\"urn:oasis:names:tc:SAML:2.0:attrname-format:unspecified\">\n" +
        "               %(groups)s\n" +
        "            </saml2:Attribute>\n" +
        "        </saml2:AttributeStatement>\n" +
        "    </saml2:Assertion>\n" +
        "</saml2p:Response>";

    public usualGroups: string[] = [
        "secgroup-online-credits-central-admissions",
        "online-credits-law",
        "online-credits-arts",
        "online-credits-bus",
        "online-credits-col",
        "online-credits-ada",
        "online-credits-eng",
        "online-credits-med",
        "online-credits-pha",
        "online-credits-it",
        "online-credits-sci",
        "online-credits-edu"];

    public onlineCourseGroup: string[] = [
        "secgroup-online-credits-oes"];

    public groups: string[] = this.usualGroups.concat(this.onlineCourseGroup);

    //isStudent = OR0038
    //isStaff = OR0041
    public staffRoles: string[] = ["IDM-GG-OR0017", "IDM-GG-OR0014", "IDM-GG-OR0003", "IDM-GG-OR0001", "IDM-GG-OR0044", "IDM-GG-OR0041"];
    public studentRoles: string[] = ["IDM-GG-OR0018", "IDM-GG-OR0029", "IDM-GG-OR0039", "IDM-GG-OR0038", "IDM-GG-OR0014",
        "IDM-GG-OR0003", "IDM-GG-OR0024", "IDM-GG-OR0045", "IDM-GG-OR0001", "IDM-GG-OR0043"];

    /* @ngInject */
    constructor(private $log: ILogService,
                private $window: IWindowService,
                private authService: AuthService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.model = new SamlResponse(this.$window.location.protocol + "//" + this.$window.location.host);
        this.selectedGroups = angular.copy(this.usualGroups, this.selectedGroups);
        this.model.isStaff = true;
    }

    public  staffChange() {
        this.selectedGroups = this.model.isStaff ? angular.copy(this.usualGroups, this.selectedGroups) : [];
    }

    public encodeSamlResponse() {
        const SAML_RESPONSE_FORMAT = "";
        const now = moment.utc();
        const dateFormat = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]";

        this.model.notBefore = now.format(dateFormat);
        this.model.notOnOrAfter = now.add(1, "hour").format(dateFormat);

        this.model.groups = "";
        this.selectedGroups.forEach((group) => {
            this.model.groups += sprintf(this.SAML_ATTRIBUTE, group);
        });


        this.model.roles = "";
        (this.model.isStaff ? this.staffRoles : this.studentRoles).forEach((role) => {
                this.model.roles += sprintf(this.SAML_ATTRIBUTE, role);
        });

        this.SAMLResponse = this.$window.btoa(sprintf(this.SAML_RESPONSE_FORMAT, this.model));
        this.$log.debug(sprintf(this.SAML_RESPONSE_FORMAT, this.model));
    }

    public getStudentDetails() {
        const loginDetails = new LoginDetails();
        this.processing = true;
        this.loadMessage = "";
        this.applicationService.getAdminStudentDetailsById(this.model.callistaPersonId)
            .then((user) => {
                if (user !== null && user.studentId !== undefined) {
                    this.model.givenName = user.givenName;
                    this.model.surname = user.familyName;
                    if (user.email != null) {
                        this.model.email = user.email;
                    }
                } else {
                    this.loadMessage = "Student not found";
                }

                this.processing = false;
            })
            .catch((error) => {
                this.processing = false;
                this.loadMessage = "Student not found";
            })
            .finally(() => {
                this.processing = false;
                }
            );

    }

}

export const LoginFormComponent2: IComponentOptions = {
    bindings: {

    },
    controller: LoginFormController2,
    template: require("./login-form.component.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/auth/login/login-form.component.ts